import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ConfigService } from './config.service';
import { ConfigLoadedGuard } from './config.guard';
import { EffectsModule } from '@ngrx/effects';
import { ConfigEffects } from './config.effects';
import { StoreModule } from '@ngrx/store';
import { reducers } from './config.store';

/**
 * Module responsible for managing ConfigModel - load and keep it in store.
 */
@NgModule({
    imports: [
        HttpClientModule,
        StoreModule.forFeature('config', reducers),
        EffectsModule.forFeature([ConfigEffects])
    ],
    declarations: [],
})
export class ConfigModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ConfigModule,
            providers: [ ConfigService, ConfigLoadedGuard ]
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.module.ts